import { render, staticRenderFns } from "./InquiryContent.vue?vue&type=template&id=1854d0dd&scoped=true&"
import script from "./InquiryContent.vue?vue&type=script&lang=js&"
export * from "./InquiryContent.vue?vue&type=script&lang=js&"
import style0 from "./InquiryContent.vue?vue&type=style&index=0&id=1854d0dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1854d0dd",
  null
  
)

export default component.exports